module.exports = __webpack_public_path__ + "img/15.861f70e9.webp";